import React from "react";
import Moment from "moment";

import { connect } from "react-redux";
import api from "../../../../store/api/api";

import NavBaseTemplate from "../../../templates/NavBaseTemplate";
import DashTabs from "../../menus/DashTabs";
import FromToDatePickerInput from "../../forms/FromToDatePickerInput";
import DashboardOfficeSelector from "../selectors/DashboardOfficeSelector";
import ScriptSelector from "../selectors/ScriptSelector";
import { setDashboardParams } from "../../../../store/actions";
import FeedbackTile from "../../modals/FeedbackTile";
import {
  pullCampaignOffices,
  pullCampaignScripts,
  updateCampaignAggregates,
} from "../../../../store/api/calls";
import DataTable from "../../tables/DataTable";

class ScriptResponseScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      showSelectionModal: !props.dashboardParams.selectedScript,
      data: [],
    };

    this.SUBMIT_DATE_FORMAT = "YYYY-MM-DD";
  }

  componentDidMount() {
    this.setState({ loading: true, error: false });
    this.props.setDashboardParams({ selectedOffice: 0 });
    let promises = [pullCampaignScripts(), pullCampaignOffices()];

    Promise.all(promises)
      .then(() => {
        if (!this.props.scripts || this.props.scripts.length === 0) {
          this.setState({ loading: false, error: true });          
          return;
        }

        if (
          !this.props.dashboardParams.selectedScript
        ) {
          console.log("no script selected", this.props.scripts[0].id);
          this.props.setSelectedScript(this.props.scripts[0].id);
        } else {
          console.log(
            "script selected",
            this.props.dashboardParams.selectedScript
          );
          return this.pullScriptData();
        }
      })
      .catch((err) => {
        console.error("Script Load Failure", err);
        this.setState({ error: true });
      })
      .then(() => {
        this.setState({ loading: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.focusedCampaign !== this.props.focusedCampaign) {
      this.setState({ loading: true, error: false });
      pullCampaignScripts().then(() => {
        this._updateCampaignAggregates();
        this.props.setDashboardParams({
          selectedOffice: 0,
          selectedScript: this.props.scripts[0].id,
        });
        this.pullScriptData().then(() => this.setState({ loading: false }));
      });
    }

    // we don't need to pull again on office so remove from comparison
    let prevParams = prevProps.dashboardParams;
    let currParams = this.props.dashboardParams;
    if (
      (prevParams.start !== currParams.start ||
        prevParams.end !== currParams.end ||
        prevParams.selectedScript !== currParams.selectedScript) &&
      this.props.dashboardParams.selectedScript
    ) {
      this.setState({ loading: true });
      this.pullScriptData().then(() => this.setState({ loading: false }));
    }
  }

  handleDateChange = (start, end) => {
    this.props.setDashboardParams({
      start: start.getTime(),
      end: end.getTime(),
    });
  };

  _updateCampaignAggregates = () => {
    return updateCampaignAggregates(
      Moment(this.props.dashboardParams.start).format(this.SUBMIT_DATE_FORMAT),
      Moment(this.props.dashboardParams.end).format(this.SUBMIT_DATE_FORMAT)
    );
  };

  pullScriptData = (script_id) => {
    this.setState({ error: false });

    const requestDateFormat = "YYYY-MM-DD";

    let params = {};

    params.start = new Moment(this.props.dashboardParams.start).format(
      requestDateFormat
    );
    params.end = new Moment(this.props.dashboardParams.end).format(
      requestDateFormat
    );
    params.office = this.props.dashboardParams.selectedOffice
      ? this.props.dashboardParams.selectedOffice
      : null;
    // params.canvasser = this.props.dashboardParams.selectedCanvasser
    //   ? this.props.dashboardParams.selectedCanvasser
    //   : null;
    params.script_id = script_id || this.props.dashboardParams.selectedScript;

    return api
      .get("/script-data/", params)
      .then((res) => {
        this.setState({ data: res.data });
        // this.props.setDashboardParams({refresh: this.props.dashboardParams.refresh ? 0 : 1})
      })
      .catch((err) => {
        this.setState({ error: true });
        console.error(err);
      });
  };

  buildOfficeScriptData(scr) {
    const tableData = (scr.responses ?? []).map((rd) => {
      const count = +rd.count;
      return {
        response: !isNaN(+rd.response) ? +rd.response : rd.response,
        count: count,
        "Percent Total": ((count / scr.total_responses) * 100).toFixed(2) + "%",
      };
    });

    scr.responses = tableData;

    return scr;
  }

  buildCampaignScriptData(display_name) {
    const scripts = this.state.data.filter(
      (d) => d.display_name === display_name
    );
    const final = { ...scripts[0], total_responses: 0, responses: {} };
    scripts.forEach((scr) => {
      if (!scr) return console.warn(`bad display_name: ${display_name}`);

      final.total_responses += scr.total_responses;

      (scr.responses ?? []).forEach((rd) => {
        if (typeof final.responses[rd.response] === "undefined") {
          final.responses[rd.response] = {
            response: rd.response,
            count: +rd.count,
            offices: [scr.office_id],
          };
        } else {
          final.responses[rd.response].count += +rd.count;
          final.responses[rd.response].offices.push(scr.office_id);
        }
      });
    });
    final.responses = Object.values(final.responses);
    final.responses.forEach((rd) => {
      rd["Percent Total"] =
        ((rd.count / final.total_responses) * 100).toFixed(2) + "%";
      rd.offices = rd.offices
        .map((id) => {
          const office = this.props.offices.find((off) => off.id === id);
          if (!office) return id;
          return office.name ?? id;
        })
        .join(", ");
    });

    return final;
  }

  renderScriptDisplay = () => {
    const seen = {};

    return this.state.data.map((d) => {
      if (!d.total_responses) return null;
      if (typeof seen[d.display_name] === "boolean") return null;

      let block = d;
      if (this.props.dashboardParams.selectedOffice > 0) {
        if (d.office_id !== this.props.dashboardParams.selectedOffice) {
          return null;
        }
        block = this.buildOfficeScriptData(d);
      } else {
        block = this.buildCampaignScriptData(d.display_name);
      }
      seen[d.display_name] = true;

      return (
        <DataTable
          noFilter
          key={block.display_name}
          data={block.responses}
          title={`${block.display_name}`}
          customSubHeader={
            <div className={"mb-4 ml-5"}>
              <div className={"is-size-4"} style={{ fontWeight: "bold" }}>
                {block.total_responses} responses
              </div>
              <div className={"is-size-4 mt-2"}>{block.prompt}</div>
            </div>
          }
        />
      );
    });
  };

  render() {
    return (
      <NavBaseTemplate>
        <DashTabs />
        <h3 className={"primary-text"}>Responses</h3>
        <div className="button-table-top-wrapper">
          <FromToDatePickerInput
            handleDateChange={this.handleDateChange}
            from={new Date(this.props.dashboardParams.start)}
            to={new Date(this.props.dashboardParams.end)}
          />

          <DashboardOfficeSelector />
          <ScriptSelector />
          {/* <DashboardCanvasserSelector /> */}
        </div>

        <div className="results-display-wrapper">
          {this.state.data.length ? (
            this.renderScriptDisplay()
          ) : (
            <div className={"card wox-card mt-4"}>
              <h6 className={"secondary-milligram-text"}>
                No data to display yet.
              </h6>
            </div>
          )}
        </div>
        <FeedbackTile
          text={
            <div>
              <i
                className=" fas fa-asterisk fa-spin"
                style={{ marginRight: "15px" }}
              />
              Loading...
            </div>
          }
          visible={this.state.loading}
        />

        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              There was a server error.
            </div>
          }
          visible={this.state.error}
          classNames={"danger"}
        />

        {/*  Script selection modal for if no script is selected on load  */}
        {/* <ScriptSelectionModal */}
        {/*   open={this.state.showSelectionModal} */}
        {/*   onClose={() => this.setState({ showSelectionModal: false })} */}
        {/*   afterSelect={(script_id) => { */}
        {/*     this.setState({ showSelectionModal: false }); */}
        {/*     this.pullScriptData(script_id); */}
        {/*   }} */}
        {/* /> */}
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  aggregates: state.aggregates.data,
  aggregates_loading: state.aggregates.loading,
  aggregates_error: state.aggregates.error,
  is_admin: state.permissions.is_admin,
  dashboardParams: state.dashboardParams,
  focusedCampaign: state.session.focusedCampaign,
  scripts: state.scripts.data,
  offices:
    state.aggregates.offices && Array.isArray(state.aggregates.offices.rows)
      ? state.aggregates.offices.rows
      : state.offices.data, // condition to support legacy
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardParams: (data) => dispatch(setDashboardParams(data)),
  setSelectedScript: (id) =>
    dispatch(setDashboardParams({ selectedScript: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScriptResponseScreen);
